/**
 * Scroll-in animations — Webflow-style "Slide in" reveals.
 *
 * Watches every element flagged with `.scroll-animation` and adds `.is-visible`
 * once it scrolls into view, letting the CSS transition play. The reveal fires
 * once per element (like Webflow's default "while scrolling into view" preset).
 *
 * Works with sections added/re-rendered in the theme editor via the
 * `shopify:section:load` event.
 */
(function () {
  'use strict';

  var SELECTOR = '.scroll-animation';
  var VISIBLE_CLASS = 'is-visible';

  // If the browser can't observe or the visitor prefers reduced motion, reveal
  // everything immediately so nothing is ever stuck hidden.
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    var scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(VISIBLE_CLASS);
    });
  }

  if (!('IntersectionObserver' in window) || prefersReducedMotion) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        revealAll();
      });
    } else {
      revealAll();
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(VISIBLE_CLASS);
        observer.unobserve(entry.target);
      });
    },
    {
      // Start the reveal slightly before the element is fully on screen,
      // matching Webflow's default trigger offset.
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    }
  );

  function observe(root) {
    var scope = root || document;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains(VISIBLE_CLASS)) return;
      observer.observe(el);
    });
  }

  function init() {
    // In the theme editor the section re-renders constantly (settings changes,
    // async recommendation morphs), which resets the reveal state and makes the
    // animation flicker/disappear. Skip the animation there and just show everything.
    if (window.Shopify && Shopify.designMode) {
      revealAll();
      return;
    }
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when a section is (re)rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
